import { createContext, useContext } from "react";
import { ToggleModal } from "types/modals";

export interface ModalContextValue {
    toggleModal: ToggleModal;
}

export const ModalContext = createContext<ModalContextValue | null>(null);

export const useModalContext = (): ModalContextValue | null => {
    return useContext(ModalContext);
};
